<template>
  <nav>
    <div class="row property-list-wrapper">
      <PropertyList v-if="showPropertyMenu" :isDash="true" />
    </div>
    <ul>
      <li>
        <router-link to="/dashboard">Dashboard</router-link>
      </li>
      <li>
        <router-link to="/suites">Suites</router-link>
      </li>
      <li>
        <router-link to="/alerts">Set Alerts</router-link>
      </li>
      <li>
        <router-link to="/waitlist">Manage Waitlist</router-link>
      </li>
      <li>
        <router-link to="/tours">Schedule Tour</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import PropertyList from "./ProperyList";
export default {
  name: 'Sidebar',
  components: {
    PropertyList
  },
  computed: {
    ...mapState('ui', ['showPropertyMenu',]),
  },
  watch: {
    showPropertyMenu: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log(`showPropertyMenu was ${oldVal} now ${newVal}`);
        
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.path == '/properties' || to.path == '/login' ) {
          if (from && from.path != '/') {
            window.setTimeout(() => {
              this.shouldShowFrame = false;
            }, 500);
          }
          else {
            this.shouldShowFrame = false;
          }

          if (from && from.path != '/login') {
            this.$store.dispatch('session/setPrevPath', from.path);
          }
        }
        else {
         this.shouldShowFrame = true; 
        }
      },
    },
    property: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.color) {
          this.accentColor = `#${newVal.color}`;
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";
.property-list-wrapper {
  margin-right: 0px;
  .properties{
    width: 100%;
  }
}
nav {
  ul {
    list-style: none;
    margin: 40px 0 0;
    padding: 0;

    li {
      margin-left: 50px;
      a {
        font-size: 1rem;
        line-height: 1.125;
        color: #939393;
        display: block;
        width: 100%;
        padding: 15px 0;

        &:hover {
          text-decoration: none;
          font-weight: 500;
          color: black;
        }

        &.router-link-exact-active {
          font-weight: 500;
          color: black;
          border-right: 9px solid var(--accentColor);
        }
      }
    }
  }
}
</style>
